import { FadeUp, Overline } from "./Reveal";

const CERTS = [
  {
    slug: "halal",
    logo: "/assets/certs/logos/halal.png",
    name: "HALAL CERTIFIED",
    desc: "Halal certification supporting our food products for applicable international markets.",
  },
  {
    slug: "apeda",
    logo: "/assets/certs/logos/apeda.png",
    name: "APEDA",
    desc: "APEDA certification and export-related compliance for eligible agricultural and processed food products.",
  },
  {
    slug: "fssai",
    logo: "/assets/certs/logos/fssai.png",
    name: "FSSAI",
    desc: "Food Safety and Standards Authority of India compliance for food business operations.",
  },
  {
    slug: "gst",
    logo: "/assets/certs/logos/gst.png",
    name: "GST",
    desc: "GST compliance for our business operations in India.",
  },
  {
    slug: "fda",
    logo: "/assets/certs/logos/fda.png",
    name: "FDA",
    desc: "FDA compliance supporting our international food-export activities.",
  },
  {
    slug: "spices-board",
    logo: "/assets/certs/logos/spices-board.jpg",
    name: "SPICES BOARD INDIA",
    desc: "Spices Board India compliance supporting our spice export activities.",
  },
];

export default function Certifications() {
  return (
    <section
      id="compliance"
      data-testid="certifications-section"
      className="border-y border-navy/10 bg-cream py-20 md:py-28"
    >
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <FadeUp className="mx-auto max-w-3xl text-center">
          <Overline>Compliance</Overline>
          <h2 className="mt-4 font-display text-3xl font-semibold uppercase leading-[1.08] tracking-tight text-navy md:text-5xl">
            Certifications & Compliance
          </h2>
          <p className="mt-4 text-base leading-relaxed text-navy/70 md:text-lg">
            Quality, Food Safety & Export Compliance
          </p>
        </FadeUp>

        <div data-testid="cert-grid" className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {CERTS.map((cert, i) => (
            <FadeUp key={cert.slug} delay={Math.min(i, 6) * 0.05}>
              <article
                data-testid={`cert-card-${cert.slug}`}
                className="flex h-full flex-col items-center rounded-2xl border border-navy/10 bg-white p-8 text-center shadow-sm shadow-navy/5 transition-[transform,border-color,box-shadow] duration-300 hover:-translate-y-1 hover:border-gold hover:shadow-xl hover:shadow-navy/10"
              >
                <div className="flex h-28 w-full items-center justify-center">
                  <img
                    src={cert.logo}
                    alt={`${cert.name} — official logo`}
                    loading="lazy"
                    className="max-h-28 max-w-full object-contain"
                  />
                </div>
                <h3 className="mt-6 font-display text-lg font-semibold tracking-tight text-navy">
                  {cert.name}
                </h3>
                <p className="mt-2.5 text-sm leading-relaxed text-navy/60">
                  {cert.desc}
                </p>
              </article>
            </FadeUp>
          ))}
        </div>

        <FadeUp delay={0.15}>
          <div
            data-testid="cert-trust-banner"
            className="relative mt-14 overflow-hidden rounded-2xl bg-navy p-8 text-center text-white md:p-14"
          >
            <div
              aria-hidden="true"
              className="absolute inset-0 opacity-[0.12]"
              style={{
                backgroundImage: "radial-gradient(circle, #ffffff 1.1px, transparent 1.1px)",
                backgroundSize: "26px 26px",
              }}
            />
            <div className="relative">
              <h3 className="font-display text-xl font-semibold uppercase tracking-[0.08em] text-gold md:text-2xl">
                Quality • Food Safety • Export Compliance
              </h3>
              <p className="mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-white/70 md:text-base">
                RBL EXIM is committed to maintaining appropriate food safety,
                quality and export compliance standards for its international
                food business.
              </p>
            </div>
          </div>
        </FadeUp>
      </div>
    </section>
  );
}
